import { render, staticRenderFns } from "./ViewAddUpdateRiderBranches.vue?vue&type=template&id=48c2c832&scoped=true"
import script from "./ViewAddUpdateRiderBranches.vue?vue&type=script&lang=js"
export * from "./ViewAddUpdateRiderBranches.vue?vue&type=script&lang=js"
import style0 from "./ViewAddUpdateRiderBranches.vue?vue&type=style&index=0&id=48c2c832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c2c832",
  null
  
)

export default component.exports